<template>
  <div :class="`absolute top-0 right-0 rounded-r w-10 h-10 flex items-center justify-center bg-gray-100 border text-gray-600 zoom-in cursor-pointer ${classes}`"
    @click="CopyClipboard(text)">
    <a>
      <Icon name="copy" classname="w-6 h-6" />
    </a>
  </div>
</template>

<script>
import Icon from '@/components/admin/partials/Icon'

export default {
  name: 'Copy',
  props: ['text','classes'],
  data() {
    return {}
  },
  async created() {

  },
  methods: {
    CopyClipboard (text) {
      //console.log(text);
      let textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);

      window.$toast.success('Contraseña copiada correctamente')
    },
  },
  components: {
    Icon
  },
}
</script>



// WEBPACK FOOTER //
// Copy.vue?7a9646cc